/* === BEGIN imported: customComponent/flatRateBox.jsx === */
import React from "react";
import {bigLockIcon} from "@img/index.js";

export function FlatRateBox() {
    return (
        <div className="hopn-flat-rate-box">
            <img src={bigLockIcon} alt="Flat Rate"/>
            <div className="hopn-flat-rate-box-text">
                <strong>Flat Rate</strong>
                <p>No Surge. No KM or Minute Charges</p>
            </div>
        </div>
    );
}
/* === END === */
